import type { BreadcrumbDesignTokens } from '@primeuix/themes/types/breadcrumb';

/**
 * Breadcrumb component tokens
 *
 * Reference implementation:
 * https://github.com/primefaces/primeuix/blob/main/packages/themes/src/presets/aura/breadcrumb/index.ts
 *
 * Component documentation:
 * https://primeng.org/breadcrumb
 */
export const breadcrumbComponentTokens: Partial<BreadcrumbDesignTokens> = {
  root: {
    background: 'transparent',
  },
};
